export default __webpack_public_path__ + "static/media/betoncard.8ced47ed.mp3";